import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransactionFailedRecord } from "../../../model/Transaction";
import { KeycloakMigrationService } from "../../../services/keycloak-migration.service";
import { EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';

@Component({
    selector: 're-keycloak-user-import-failed',
    templateUrl: './keycloak-user-import-failed.component.html',
    styleUrls: ['./keycloak-user-import-failed.component.scss'],
    standalone: false
})
export class KeycloakUserImportFailedComponent {
  constructor(private keycloakService: KeycloakMigrationService, private route: ActivatedRoute) { }

  failedUsers: TransactionFailedRecord[];

  load($event: EventEmitterWithObservable) {
    $event.ReturnValue = this.keycloakService.getFailedUsers(+this.route.snapshot.params.processId);
  }
}
